import { Grid } from '@material-ui/core';
import { Button, Col, Row } from 'antd';
import React from 'react';
import DetailItem from '../../../../CSIComponents/DetailItem';
import styles from '../../index.module.css'

const isDecimal = (num: number) => {
    if (Number(num)) {
        return Number(num).toFixed(2)
    }
    return ''
}

const ExtraFacilityView = (props: any) => {
    const detailData = [     
        { label: 'AV Equipment', value: props.facilityData.avequiment, span: 6 },
        { label: 'Other AV Equipment Fee', value: props.facilityData.avequipfee, span: 6 },
        { span: 8 },
        { label: 'In-House AV Equipment Company Name', value: props.facilityData.avequipconame, span: 6 },
        { label: 'Discount on In-House AV Equipment', value: props.facilityData.avequipdiscount, span: 6 },
        { span: 8 },
        { label: 'Overhead Projector', value: props.facilityData.overheadprojector, span: 6 },
        { label: 'Slide Projector', value: props.facilityData.slideprojector, span: 6 },
        { span: 8 },
        { label: 'Screen for Projector', value: props.facilityData.screenprotec, span: 6 },
        { label: 'Screen Charge Per Day (USD)', value: isDecimal(props.facilityData?.screenperday), span: 6 },
        { span: 8 },
        { label: 'LCD Projector', value: props.facilityData.lcdprojector, span: 6 },
        { label: 'LCD Cost Per Day (USD)', value: isDecimal(props.facilityData?.lcdcostperday), span: 6 },
        { span: 8 },
        { label: 'Sound Equipment', value: props.facilityData.soundequip, span: 6 },
        { label: 'Allows Other Audio Visual Equipment', value: props.facilityData.allowotheravequip, span: 6 },
        { span: 8 },
        { label: 'Microphones Portable', value: props.facilityData.portablemic, span: 6 },
        { label: 'Microphones Stationary', value: props.facilityData.stationarymic, span: 6 },
        { label: 'Microphones Wireless', value: props.facilityData.microwireless, span: 6 },
        { span: 6 },
        { label: 'High Speed Internet', value: props.facilityData.highspeedinternet, span: 6 },
        { label: 'High Speed Internet Charge (USD)', value: isDecimal(props.facilityData?.highspeedinternetcharge), span: 6 },
        { span: 8 },
        { label: 'High Speed Wireless Internet', value: props.facilityData.highspeedwirelessinternet, span: 6 },
        { label: 'High Speed Wireless Internet Charge (USD)', value: isDecimal(props.facilityData?.highspeedwirelesscharge), span: 6 },
        { span: 8 },
        { label: 'Video Conferencing', value: props.facilityData.videoconf, span: 6 },
        { label: 'Video Camera', value: props.facilityData.videocamera, span: 6 },
        { span: 8 },
        { label: 'Teleconferencing', value: props.facilityData.teleconf, span: 6 },
        { label: 'Monitor', value: props.facilityData.monitor, span: 6 },
        { span: 8 },
        { label: 'Whiteboards', value: props.facilityData.whiteboards, span: 6 },
        { label: 'Bulletin / Message Board', value: props.facilityData.bulletinmessageboard, span: 6 },
        { span: 8 },
        { label: 'Lecturn', value: props.facilityData.lecturn, span: 6 },
        { label: 'Platform', value: props.facilityData.platform, span: 6 },
        { span: 8 },
        { label: 'Easels', value: props.facilityData.easels, span: 6 },
        { label: 'Flipchart', value: props.facilityData.flipchart, span: 6 },
        { span: 8 },
        { label: 'Technical Support', value: props.facilityData.techsupport, span: 6 },
        { span: 8 },
    ]

    return (
        <>
            <div className={styles.outCon}>
                <div className={styles.inCon}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#333', paddingLeft: '10px' }}>Extra Facility</div>
                    <Button type='primary' className='db-edit-btn' onClick={() => { props.setEditFlag(true); window.editFunction(); props.setOneNavDisabled(true) }}>Edit</Button>
                </div>
                <Grid item xs={12} className={styles.pdLeft}>
                    <Row gutter={24}>
                        {detailData.map((item, i) => {
                            return item.label ? <Col span={item.span} key={i} className="col-margin">
                                <DetailItem value={item.value} label={item.label} />
                            </Col> : <Col span={item.span} key={i}></Col>
                        })
                        }
                    </Row>
                </Grid>
            </div>
        </>
    )
}
export default ExtraFacilityView;
